import api from "./api";

// Capa de servicios API del dominio "dashboard" (conexiones + reportes de tickets) (FSD / capa API transversal).
export const getDashboardConnections = () => api.get("/dashboard/connections");
export const updateDashboardConnectionsThresholds = (payload) =>
  api.put("/dashboard/connections/thresholds", payload);
export const getTicketsDayReport = (params) =>
  api.get("/dashboard/ticketsDay", { params });
export const getTicketsUsersReport = (params) =>
  api.get("/dashboard/ticketsUsers", { params });
